import React from 'react';
import clsx from 'clsx';

import './styles.scss';

import Icon, { CircleIcon } from '../icon/icon';
import PolicyIcon from '../PolicyIcon';
import DisclosurePanel from '../DisclosurePanel';
import StatusFlag from '../StatusFlag';
import Tags, { Tag } from '../Tags';
import Button from '../button/button.jsx';
import SourceLink from '../SourceLink';

import { formatFriendlyUrl, formatYearSpan } from '../../utilities/formatters.js';

export default function PoliciesList({ policies, onClickPolicy }) {
  if (!policies.length) {
    return (
      <div className="policies-list policies-list--empty">
        <h1>No policies for this selection</h1>
        <p>Please select different policy type, year or location</p>
      </div>
    );
  }

  return (
    <div className="policies-list">
      {policies.map((group) => {
        return (
          <div className="policies-list__group" key={group.type.model.name}>
            <div className="policies-list__group-header">
              <h1>{group.type.model.name}</h1>
            </div>
            <ul className="policies-list__group-list">
              {group.children.map((child) => {
                // if (!child.group) {
                //   return <PolicyListItem item={child} />;
                // }

                return (
                  <li
                    key={child.type.id}
                    // style={{ '--accent-colour': child.type.model.icon?.colour }}
                    // style={{ '--accent-colour': child.type.model.colour }}
                  >
                    <div className="policies-list__header">
                      {/* <PolicyIcon options={child.type.model.icon} /> */}
                      <PolicyIcon
                        options={{ id: child.type.model.iconId, colour: child.type.model.colour }}
                      />
                      <h1>
                        {child.type.model.name} (
                        {child.count !== undefined ? child.count : child.children.length})
                      </h1>
                    </div>
                    {child.children ? (
                      <ul className="policies-list__list">
                        {child.children.map((item) => {
                          if (item.children?.length) {
                            return (
                              <li
                                className="policies-list__list__group"
                                style={{ '--accent-colour': item.group.colour }}
                              >
                                <div className="policies-list__list__group__header">
                                  <PolicyIcon options={{ colour: item.group.colour }} />
                                  <h4>
                                    {item.group.name || item.group} (
                                    {item.count !== undefined ? item.count : item.children.length})
                                  </h4>
                                </div>
                                <ul className="policies-list__list__group__body">
                                  {item.children.map((childItem) => {
                                    return (
                                      <PolicyListItem item={childItem} onClick={onClickPolicy} />
                                    );
                                  })}
                                </ul>
                              </li>
                            );
                          } else {
                            return <PolicyListItem item={item} onClick={onClickPolicy} />;
                          }
                        })}
                      </ul>
                    ) : null}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
}

function PolicyListItem({ item, onClick }) {
  const hasDetails = onClick && item.actions && item.actions.length;

  return (
    <li class="policy-list-item">
      <DisclosurePanel
        icon_id="accordion"
        type="accordion"
        disabled={hasDetails || (!item.description && !item.source)}
      >
        <div
          className={clsx(
            'policy-list-item__header',
            hasDetails && 'policy-list-item__header--parent'
          )}
        >
          <h1>
            {item.title}
            {/* {item.status && <StatusFlag status={item.status} />} */}
          </h1>
          {hasDetails ? (
            <div>
              <Button handleClick={() => onClick(item.id)} kind="details">
                View more
              </Button>
            </div>
          ) : undefined}
          <p>
            {item.responsible && `${item.responsible.trim()}, `}
            {item.statusDetail ? item.statusDetail : formatYearSpan(item.startYear, item.endYear)}
            {item.count !== undefined
              ? ` ${item.count} item${item.count > 1 ? 's' : ''}`
              : undefined}
          </p>
        </div>
        <div className="policy-list-item__body">
          <div
            className="policy-list-item__desc"
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          {item.extraFields && (
            <div className="policy-list-item__section">
              {item.extraFields.map((field) => {
                return (
                  <>
                    <h2 className="policy-list-item__section-header">{field.title}</h2>
                    <div className="policy-list-item__section-body">
                      <p>{field.value}</p>
                    </div>
                  </>
                );
              })}
            </div>
          )}
          {item.source && (
            <div className="policy-list-item__section">
              <h4 className="policy-list-item__section-header">Sources</h4>
              <ul className="policy-list-item__sources">
                {item.source.map((source) => {
                  return (
                    <li>
                      <SourceLink href={source} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {/* {item.relatedPublications && item.relatedPublications.length ? (
            <div className="policy-list-item__section">
              <h2 className="policy-list-item__section-header">Related publications</h2>
              <ul>
                {item.relatedPublications.map((publication) => {
                  return (
                    <li>
                      <a
                        className="policy-list-item__publication"
                        href={publication.url}
                        target="_blank"
                      >
                        <span>{publication.title}</span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : undefined} */}
          {item.sectors && item.sectors.length ? (
            <div className="policy-list-item__section">
              <h2 className="policy-list-item__section-header">Targeted Sectors</h2>
              <Tags>
                {item.sectors.map((sector) => (
                  <Tag>{sector}</Tag>
                ))}
              </Tags>
            </div>
          ) : undefined}
        </div>
      </DisclosurePanel>
    </li>
  );
}
